module.exports = __webpack_public_path__ + "img/rtb_silo_2.10f606f6.png";